import MenuStore from './MenuStore';
export default new MenuStore();
